import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import ThumbsUpButton from '../components/buttons/ThumbsUpButton';
import ThumbsDownButton from '../components/buttons/ThumbsDownButton';
import createRating from '../utils/createRating';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import SubmitArrowButton from './buttons/SubmitArrowButton';

const { Text } = Typography;
const { TextArea } = Input;

const ThumbsRating = ({ rateableUuid, rateableType, hint = null }) => {
  const [buttonsHidden, setButtonsHidden] = useState(false);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const handleRatingSubmitted = async (isDownvote = false) => {
    try {
      await createRating(rateableUuid, rateableType, isDownvote ? -1 : 1);
      setButtonsHidden(true);
      if (isDownvote) {
        setShowFeedbackForm(true);
      } else {
        toast.success(t('ratings.success'));
      }
    } catch (error) {
      toast.error(t('common.error'));
      setButtonsHidden(false);
    }
  };

  const handleFeedbackSubmit = async (values) => {
    try {
      await createRating(rateableUuid, rateableType, -1, values.feedback);
      setShowFeedbackForm(false);
      toast.success(t('common.submitted'));
    } catch (error) {
      toast.error(t('common.error'));
    }
  };

  useEffect(() => {
    // Unhide the buttons and reset form when the rateableUuid changes
    setButtonsHidden(false);
    setShowFeedbackForm(false);
    form.resetFields();
  }, [rateableUuid, form]);

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
      {!buttonsHidden ? (
        <>
          <ThumbsUpButton
            rateableUuid={rateableUuid}
            rateableType={rateableType}
            onRatingSubmitted={() => handleRatingSubmitted(false)}
          />
          <ThumbsDownButton
            rateableUuid={rateableUuid}
            rateableType={rateableType}
            onRatingSubmitted={() => handleRatingSubmitted(true)}
          />
          {hint && (
            <div style={{ marginLeft: '5px' }}>
              <Text type="secondary">{hint}</Text>
            </div>
          )}
        </>
      ) : showFeedbackForm ? (
        <Form
          form={form}
          onFinish={handleFeedbackSubmit}
          style={{ width: '300px' }}
        >
          <Form.Item
            name="feedback"
            rules={[
              { required: true, message: t('ratings.fields.feedback_required') }
            ]}
            style={{ marginBottom: 0 }}
          >
            <div style={{ position: 'relative' }}>
              <Input
                placeholder={t('ratings.fields.feedback_placeholder')}
                style={{ paddingRight: '40px', paddingBottom: '5px', paddingTop: '5px' }}
              />
              <SubmitArrowButton
                onClick={() => {
                  const value = form.getFieldValue('feedback');
                  if (value) {
                    form.submit();
                  }
                }}
                style={{
                  height: '24px',
                  width: '40px',
                  right: '4px',
                  bottom: '6px'
                }}
              />
            </div>
          </Form.Item>
        </Form>
      ) : (
        <div style={{ width: '85px' }} />
      )}
    </div>
  );
};

export default ThumbsRating;
